(function () {
  'use strict';

  var CFG = window.CRO_TRACKING;
  if (!CFG || !CFG.enabled || window.__croTrackingBooted) return;
  window.__croTrackingBooted = true;

  var VERSION = '1.1.1';
  var DEBUG = CFG.debug || /[?&]cro_debug=1/.test(location.search) || storeGet(localStorage, 'cro_debug') === '1';
  var pageLoadTs = Date.now();
  var lastPointerTs = 0;
  var lastPointerTarget = null;
  var mobileMQ = window.matchMedia('(max-width: 999px)');

  /* ------------------------------------------------------------------ utils */
  function storeGet(store, k) { try { return store.getItem(k); } catch (e) { return null; } }
  function storeSet(store, k, v) { try { store.setItem(k, v); } catch (e) { /* private mode */ } }
  /** List context handed over by the last product card click (same tab, ≤30 min). Lets PDP events and add-to-cart be tied back to the listing. */
  function sourceList() {
    var raw = storeGet(sessionStorage, 'cro_list_ctx');
    if (!raw) return {};
    try {
      var c = JSON.parse(raw);
      if (!c || !c.ts || Date.now() - c.ts > 30 * 60 * 1000) return {};
      return { source_list_id: c.list_id, source_list_position: c.index, source_item_id: c.item_id };
    } catch (e) { return {}; }
  }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function txt(el, max) {
    if (!el) return '';
    var t = (el.getAttribute && (el.getAttribute('aria-label') || el.getAttribute('data-swatch-tooltip'))) || el.textContent || '';
    t = t.replace(/\s+/g, ' ').trim();
    return max ? t.slice(0, max) : t;
  }
  function pathOf(href) {
    if (!href) return '';
    try { return new URL(href, location.origin).pathname; } catch (e) { return String(href).split('?')[0]; }
  }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? undefined : n; }
  function indexAmong(el, selector, scope) {
    if (!el) return undefined;
    var list = qsa(selector, scope || el.parentNode);
    var i = list.indexOf(el);
    return i >= 0 ? i + 1 : undefined;
  }
  function isVisible(el) {
    // Note: offsetParent is null inside <dialog>/top-layer containers (cart drawer), so it is not used here.
    if (!el || !el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function clean(obj) {
    var out = {};
    Object.keys(obj || {}).forEach(function (k) {
      var v = obj[k];
      if (v === undefined || v === null || v === '') return;
      out[k] = v;
    });
    return out;
  }
  var lastKeys = [];
  function push(event, params) {
    var payload = Object.assign({
      event: event,
      tracking_version: VERSION,
      page_type: CFG.pageType,
      template: CFG.template,
      customer_type: CFG.customerType,
      device_layout: mobileMQ.matches ? 'mobile' : 'desktop'
    }, clean(params));
    var keys = Object.keys(payload);
    // GTM's data model keeps every key ever pushed, and the GA4 tag reads all of them on every event.
    // Unset the previous event's keys that this one doesn't carry, so they don't leak onto this hit.
    var out = Object.assign({}, payload);
    lastKeys.forEach(function (k) { if (!(k in payload)) out[k] = undefined; });
    lastKeys = keys;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(out);
    if (DEBUG) console.log('[cro]', event, payload);
  }
  /** Delegated capture-phase listener (fires before theme handlers that call form.submit()/location.assign()). */
  function on(type, selector, handler) {
    document.addEventListener(type, function (e) {
      var t = e.target && e.target.closest ? e.target.closest(selector) : null;
      if (t) handler(e, t);
    }, true);
  }
  function sectionInfo(el) {
    var sec = el && el.closest ? el.closest('.shopify-section') : null;
    if (!sec) return {};
    var id = (sec.id || '').replace('shopify-section-', '');
    var key = id.split('__').pop();
    var type = key.replace(/_[A-Za-z0-9]{6,}$/, '');
    var parent = sec.parentNode;
    var pos = parent ? Array.prototype.indexOf.call(parent.children, sec) + 1 : undefined;
    return { section_id: key, section_type: type, section_position: pos };
  }
  function scrubTerm(term) {
    term = (term || '').trim().toLowerCase().slice(0, 100);
    if (!term) return undefined;
    if (/@|\d{5,}/.test(term)) return '[redacted]';
    return term;
  }
  function recentPointer(ms) { return Date.now() - lastPointerTs < (ms || 700); }

  document.addEventListener('pointerdown', function (e) { lastPointerTs = Date.now(); lastPointerTarget = e.target; }, true);
  document.addEventListener('touchstart', function (e) { lastPointerTs = Date.now(); lastPointerTarget = e.target; }, { capture: true, passive: true });
  document.addEventListener('keydown', function (e) { lastPointerTs = Date.now(); lastPointerTarget = e.target; }, true);

  /* ------------------------------------------------------- visibility helper */
  var vis = (function () {
    var active = new Map(); // el -> {cb, threshold, delay, timer}
    var supported = 'IntersectionObserver' in window;
    var io = supported ? new IntersectionObserver(onEntries, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.75, 1] }) : null;

    function fractionVisible(el) {
      var r = el.getBoundingClientRect();
      var area = r.width * r.height;
      if (!area) return 0;
      var h = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
      var w = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0));
      return (h * w) / area;
    }
    function autoThreshold(el) {
      var h = el.offsetHeight || 0;
      return h > window.innerHeight ? Math.min(0.5, (window.innerHeight * 0.5) / h) : 0.5;
    }
    /** Auto thresholds are measured at check time: app widgets (Yotpo) are empty when observed and grow taller than the viewport later. */
    function thresholdOf(el, rec) { return rec.threshold != null ? rec.threshold : autoThreshold(el); }
    function arm(el, rec) {
      if (rec.timer) return;
      rec.timer = setTimeout(function () {
        rec.timer = null;
        if (document.visibilityState !== 'visible') return;
        if (!document.contains(el) || !isVisible(el) || fractionVisible(el) < thresholdOf(el, rec)) return;
        release(el);
        rec.cb(el);
      }, rec.delay);
    }
    function disarm(rec) { if (rec.timer) { clearTimeout(rec.timer); rec.timer = null; } }
    function onEntries(entries) {
      entries.forEach(function (en) {
        var rec = active.get(en.target);
        if (!rec) return;
        var ok = en.isIntersecting && en.intersectionRatio >= thresholdOf(en.target, rec) && document.visibilityState === 'visible';
        if (ok) arm(en.target, rec); else disarm(rec);
      });
    }
    function observe(el, cb, opts) {
      if (!supported || !el || active.has(el)) return;
      opts = opts || {};
      var rec = { cb: cb, threshold: opts.threshold, delay: opts.delay != null ? opts.delay : 1000, timer: null };
      active.set(el, rec);
      io.observe(el);
    }
    function release(el) {
      var rec = active.get(el);
      if (!rec) return;
      disarm(rec);
      io.unobserve(el);
      active.delete(el);
    }
    document.addEventListener('visibilitychange', function () {
      active.forEach(function (rec, el) {
        disarm(rec);
        if (document.visibilityState === 'visible') { io.unobserve(el); io.observe(el); }
      });
    });
    return { observe: observe, release: release };
  })();

  /** Observe current + future elements matching selector (MutationObserver, batched). */
  var watchers = [];
  function observeAll(selector, cb, root) {
    var w = { selector: selector, cb: cb, root: root || document, seen: new WeakSet() };
    watchers.push(w);
    runWatcher(w);
  }
  function runWatcher(w) {
    if (!document.contains(w.root) && w.root !== document) return;
    qsa(w.selector, w.root).forEach(function (el) {
      if (w.seen.has(el)) return;
      w.seen.add(el);
      w.cb(el);
    });
  }
  var mutationQueued = false;
  var bodyObserver = new MutationObserver(function () {
    if (mutationQueued) return;
    mutationQueued = true;
    requestAnimationFrame(function () {
      mutationQueued = false;
      watchers.forEach(runWatcher);
      domChangedHooks.forEach(function (fn) { fn(); });
    });
  });
  var domChangedHooks = [];
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });

  /* ------------------------------------------------------------ cart cache */
  var cartCache = null;
  var cartOpenSource = { value: 'other', ts: 0 };
  function setCartSource(v) { cartOpenSource = { value: v, ts: Date.now() }; }
  function getCartSource() { return (Date.now() - cartOpenSource.ts < 6000) ? cartOpenSource.value : 'other'; }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) cartCache = c; return c; })
      .catch(function () { return cartCache; });
  }
  function cartParams(c) {
    c = c || cartCache;
    if (!c) return {};
    return { cart_value: (c.total_price || 0) / 100, currency: c.currency, item_count: c.item_count };
  }
  document.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    if (d.cart) cartCache = d.cart;
    if (d.baseEvent === 'variant:add') setCartSource('after_atc');
  });
  document.addEventListener('cart:open', function () { setCartSource('quick_add'); });

  /* =================================================================== NAV */
  function initNav() {
    var header = qs('.cn-header-wrapper');
    if (!header) return;

    var menuState = new Map(); // panel el -> {openedAt, pushed, selected, timer, meta}
    function menuMeta(el) {
      if (el.matches('[data-cn-drawer]')) return { menu_type: 'mobile', menu_level: 1, parent_item: 'drawer' };
      if (el.matches('[data-cn-mega]')) {
        var trig = qs('[data-cn-mega-trigger="' + el.getAttribute('data-cn-mega') + '"]');
        return { menu_type: 'desktop', menu_level: 1, parent_item: el.getAttribute('aria-label') || txt(trig, 40) };
      }
      if (el.matches('[data-cn-dropdown]')) {
        var t2 = qs('[data-cn-dropdown-trigger="' + el.getAttribute('data-cn-dropdown') + '"]');
        return { menu_type: 'desktop', menu_level: 1, parent_item: txt(t2, 40) };
      }
      return { menu_type: 'desktop', menu_level: 1 };
    }
    function onMenuToggle(el) {
      var open = el.classList.contains('is-active');
      var st = menuState.get(el);
      if (open && !st) {
        st = { openedAt: Date.now(), pushed: false, selected: false, meta: menuMeta(el), viewSet: new Set() };
        menuState.set(el, st);
        var delay = st.meta.menu_type === 'desktop' ? 500 : 0; // ignore hover pass-overs
        st.timer = setTimeout(function () {
          st.pushed = true;
          push('menu_open', st.meta);
          if (st.meta.menu_type === 'mobile') observeDrawerItems(el, st);
        }, delay);
      } else if (!open && st) {
        clearTimeout(st.timer);
        menuState.delete(el);
        st.viewSet.forEach(function (item) { vis.release(item); });
        if (st.pushed) push('menu_close', Object.assign({}, st.meta, { time_open_ms: Date.now() - st.openedAt, selection_made: st.selected }));
      }
    }
    function observeDrawerItems(drawer, st) {
      qsa('.cn-drawer__link, .cn-drawer__style-item, .cn-drawer__footer-list a', drawer).forEach(function (a) {
        st.viewSet.add(a);
        vis.observe(a, function () {
          push('nav_item_view', {
            menu_type: 'mobile', menu_level: 2,
            parent_item: genderLabel(txt(a.closest('[data-cn-panel]') ? qs('.cn-drawer__tab.is-active, .cn-drawer__tab.active, .cn-drawer__tab[aria-selected="true"]', drawer) : null, 30)) || drawerHeadline(a),
            item_label: txt(a, 60), item_position: indexAmong(a, 'a'), destination_path: pathOf(a.href)
          });
        }, { threshold: 0.5, delay: 1000 });
      });
    }
    function drawerHeadline(a) {
      var sec = a.closest('.cn-drawer__section, .cn-drawer__group, li, div');
      var h = sec ? qs('.cn-drawer__headline-text', sec) : null;
      return txt(h, 40);
    }
    var panels = qsa('[data-cn-mega], [data-cn-dropdown], [data-cn-drawer]');
    var mo = new MutationObserver(function (muts) { muts.forEach(function (m) { onMenuToggle(m.target); }); });
    panels.forEach(function (p) { mo.observe(p, { attributes: true, attributeFilter: ['class'] }); });

    // Drawer tab switch → re-observe visible items
    on('click', '.cn-drawer__tab', function (e, tab) {
      var drawer = tab.closest('[data-cn-drawer]');
      var st = drawer && menuState.get(drawer);
      push('nav_click', { menu_type: 'mobile', menu_level: 1, item_label: genderLabel(txt(tab, 30)), item_position: indexAmong(tab, '.cn-drawer__tab'), interaction: 'tab' });
      if (st && st.pushed) setTimeout(function () { observeDrawerItems(drawer, st); }, 50);
    });

    function markSelected(a) {
      menuState.forEach(function (st, panel) { if (panel.contains(a)) st.selected = true; });
    }

    /** Link text without badges ("Prima" not "PrimaWaterproof"); drawer tab "Women's" → "Women" so mobile and desktop share one value. */
    function navLabel(a) {
      var name = qs('.cn-shoe-name, .cn-drawer__style-title', a);
      if (name) return txt(name, 60);
      if (!qs('.cn-badge', a) || a.getAttribute('aria-label')) return txt(a, 60);
      var c = a.cloneNode(true);
      qsa('.cn-badge', c).forEach(function (b) { b.remove(); });
      return txt(c, 60);
    }
    function genderLabel(t) { return (t || '').replace(/['\u2019]s$/i, ''); }

    on('click', '.cn-header-wrapper a[href], [data-cn-drawer] a[href], .cn-mobile-bar a[href]', function (e, a) {
      if (a.closest('[data-cn-search], [data-cn-offers], [data-cn-announcement]')) return; // handled elsewhere
      if (a.matches('[aria-controls="cart-drawer"], [data-cn-open-cart]') || a.closest('[data-cn-open-cart]')) {
        setCartSource(a.closest('.cn-mobile-bar') ? 'mobile_bar' : 'header');
        return;
      }
      var inDrawer = !!a.closest('[data-cn-drawer]');
      var inBar = !!a.closest('.cn-mobile-bar');
      var p = { menu_type: inDrawer ? 'mobile' : (inBar ? 'mobile_bar' : 'desktop'), destination_path: pathOf(a.href), item_label: navLabel(a), source_page_type: CFG.pageType };
      var mega = a.closest('[data-cn-mega]');
      var drop = a.closest('[data-cn-dropdown]');
      if (mega) {
        p.menu_level = 2;
        p.parent_item = mega.getAttribute('aria-label') || txt(qs('[data-cn-mega-trigger="' + mega.getAttribute('data-cn-mega') + '"]'), 40);
        var col = a.closest('.cn-mega__col');
        p.group_label = col ? txt(qs('.cn-mega__title', col), 40) : (a.matches('.cn-shoe-item') ? 'shop_by_style' : undefined);
        p.item_position = indexAmong(a, 'a', col || mega);
      } else if (drop) {
        var sec = a.closest('.cn-dropdown__section');
        p.menu_level = sec ? 3 : 2;
        p.parent_item = txt(qs('[data-cn-dropdown-trigger="' + drop.getAttribute('data-cn-dropdown') + '"]'), 40);
        p.group_label = sec ? txt(qs('.cn-dropdown__section-title', sec), 40) : undefined;
        p.item_position = indexAmong(a, 'a', sec || drop);
      } else if (inDrawer) {
        p.menu_level = a.matches('.cn-drawer__footer-list a') ? 1 : 2;
        p.parent_item = genderLabel(txt(qs('.cn-drawer__tab.is-active, .cn-drawer__tab.active, .cn-drawer__tab[aria-selected="true"]', a.closest('[data-cn-drawer]')), 30));
        p.group_label = drawerHeadline(a) || (a.matches('.cn-drawer__style-item') ? 'shop_by_style' : undefined);
        p.item_position = indexAmong(a, 'a', a.closest('ul, .cn-drawer__section, .cn-drawer__group') || a.parentNode);
      } else {
        p.menu_level = 1;
        p.item_position = indexAmong(a, 'a', a.closest('.cn-nav--left, .cn-nav--right, .cn-mobile-bar, nav') || a.parentNode);
        if (a.matches('[data-cn-mega-trigger], [data-cn-dropdown-trigger]')) p.interaction = 'trigger_link';
      }
      if (a.matches('.cn-nav-link--sale, .cn-mega__link--sale')) p.is_sale = true;
      markSelected(a);
      push('nav_click', p);
    });

    // Offers popup
    on('click', '[data-cn-toggle="offers"]', function (e, b) {
      var overlay = qs('[data-cn-offers]');
      var opening = overlay && !overlay.classList.contains('is-active');
      push(opening ? 'offers_open' : 'offers_close', { source: b.closest('.cn-nav--mobile') ? 'mobile' : 'desktop' });
    });
    on('click', '[data-cn-offers] a[href]', function (e, a) {
      var card = a.closest('.cn-offers__card');
      push('offers_click', { offer_position: card ? indexAmong(card, '.cn-offers__card') : undefined, offer_label: txt(card ? qs('h3, h4, .cn-offers__card-title', card) : a, 60), destination_path: pathOf(a.href) });
    });
    on('click', '[data-cn-offers-prev], [data-cn-offers-next]', function (e, b) {
      push('carousel_navigate', { section_type: 'offers', interaction_method: 'arrow', change_source: 'user', direction: b.hasAttribute('data-cn-offers-next') ? 'next' : 'prev' });
    });
    // Announcement bar
    on('click', '[data-cn-announcement] a[href]', function (e, a) {
      push('content_click', { section_type: 'announcement', content_id: 'announcement', destination_path: pathOf(a.href), item_label: txt(a, 60) });
    });
  }

  /* ================================================================ SEARCH */
  function initSearch() {
    var overlay = qs('[data-cn-search]');
    var st = { openedAt: 0, submitted: false, lastResultsKey: '' };

    on('click', '[data-cn-toggle="search"]', function () {
      st.openedAt = Date.now(); st.submitted = false;
      push('search_open', { source_page_type: CFG.pageType });
    });
    if (overlay) {
      new MutationObserver(function () {
        if (!overlay.classList.contains('is-active') && st.openedAt) {
          push('search_close', { submitted: st.submitted, time_open_ms: Date.now() - st.openedAt });
          st.openedAt = 0;
        }
      }).observe(overlay, { attributes: true, attributeFilter: ['class'] });

      var grid = qs('[data-cn-search-results-grid]', overlay);
      var noRes = qs('[data-cn-search-no-results]', overlay);
      var input = qs('input.cn-search__input', overlay);
      var debounce = null;
      function reportOverlayResults() {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          var zero = noRes ? isVisible(noRes) : false;
          var count = grid ? qsa('[data-gpcard]', grid).length : 0;
          var countEl = qs('[data-cn-search-count]', overlay);
          var m = countEl ? (txt(countEl).match(/\d+/) || [])[0] : null;
          var term = scrubTerm(input && input.value);
          if (!term || (!zero && !count)) return;
          var key = term + '|' + zero + '|' + (m || count);
          if (key === st.lastResultsKey) return;
          st.lastResultsKey = key;
          push('search_results_view', { search_type: 'autocomplete', term: term, results_count: zero ? 0 : (num(m) !== undefined ? num(m) : count), zero_results: zero });
        }, 400);
      }
      if (grid) new MutationObserver(reportOverlayResults).observe(grid, { childList: true });
      if (noRes) new MutationObserver(reportOverlayResults).observe(noRes, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });

      overlay.addEventListener('submit', function (e) {
        var f = e.target; var inp = qs('input[name="q"]', f);
        st.submitted = true;
        push('search_submit', { search_type: 'overlay', term: scrubTerm(inp && inp.value), query_length: inp ? inp.value.length : 0 });
      }, true);
      on('click', '[data-cn-search-term]', function (e, el) {
        st.submitted = true;
        push('search_submit', { search_type: 'suggested_term', term: scrubTerm(el.getAttribute('data-cn-search-term') || txt(el)) });
      });
      on('click', '.cn-search__suggest-item', function (e, el) {
        st.submitted = true;
        push('search_submit', { search_type: 'autocomplete', term: scrubTerm(el.getAttribute('data-cn-suggest') || txt(el)), result_position: indexAmong(el, '.cn-search__suggest-item') });
      });
      on('click', '[data-cn-search-results-grid] a[href]', function (e, a) {
        var card = a.closest('[data-gpcard]');
        st.submitted = true;
        push('search_result_click', { search_type: 'autocomplete', term: scrubTerm(input && input.value), result_position: card ? indexAmong(card, '[data-gpcard]', grid) : undefined, item_id: card && card.getAttribute('data-product-id'), item_name: card && card.getAttribute('data-product-title'), destination_path: pathOf(a.href) });
      });
      on('click', '[data-cn-search-view-all]', function (e, a) {
        st.submitted = true;
        push('search_submit', { search_type: 'view_all', term: scrubTerm(input && input.value) });
      });
      on('click', '[data-cn-search-defaults] a[href]', function (e, a) {
        var card = a.closest('[data-gpcard]');
        push('search_result_click', { search_type: 'trending_default', destination_path: pathOf(a.href), item_id: card && card.getAttribute('data-product-id'), item_name: (card && card.getAttribute('data-product-title')) || txt(a, 60), result_position: card ? indexAmong(card, '[data-gpcard]', card.parentNode) : undefined });
      });
    }

    // Results page
    if (CFG.pageType === 'search') {
      var countEl = qs('[data-goc-count-value]');
      var count = countEl ? num(txt(countEl)) : undefined;
      var zero = window.__gocSearchNoResults === true || !!qs('.goc-search__empty') || count === 0;
      push('search_results_view', {
        search_type: 'results_page', term: scrubTerm(CFG.searchTerms), results_count: zero ? 0 : count,
        zero_results: zero, corrected: /[?&]corrected=1/.test(location.search)
      });
      document.addEventListener('submit', function (e) {
        if (!e.target.matches('form.goc-search-header__form')) return;
        var inp = qs('input', e.target);
        push('search_submit', { search_type: 'results_page', term: scrubTerm(inp && inp.value), query_length: inp ? inp.value.length : 0 });
      }, true);
      on('click', '[data-goc-suggest]', function (e, el) {
        push('search_submit', { search_type: 'results_page_suggestion', term: scrubTerm(el.getAttribute('data-goc-suggest') || txt(el)) });
      });
    }
  }

  /* ===================================================== SECTIONS / CONTENT */
  function initSections() {
    // Section visibility (all templates; header/footer/overlay sections excluded by scope)
    observeAll('#main .shopify-section, #MainContent .shopify-section, main .shopify-section', function (sec) {
      if (sec.closest('.cn-header-wrapper')) return;
      vis.observe(sec, function () {
        var info = sectionInfo(sec);
        push('section_view', Object.assign(info, { section_title: txt(qs('h1, h2', sec), 60) }));
      });
    });

    // Generic content click on landing-type templates
    var contentTemplates = { index: 1, page: 1, article: 1, blog: 1, list_collections: 1, collection: 1 };
    if (contentTemplates[CFG.pageType]) {
      on('click', '#main .shopify-section a[href], #MainContent .shopify-section a[href], main .shopify-section a[href]', function (e, a) {
        if (a.closest('[data-gpcard], [data-gocplp-root], [data-gocrev-wrap], .cn-header-wrapper, [data-cn-drawer], .quiz-results__collection')) return;
        var info = sectionInfo(a);
        var blockEl = a.closest('[data-block-id]');
        var posEl = a.closest('[data-position]');
        var img = qs('img', a);
        var panel = a.closest('.hp-collections__panel');
        var p = Object.assign(info, {
          content_id: a.getAttribute('data-content-id') || (blockEl && blockEl.getAttribute('data-block-id')) || txt(a, 40).toLowerCase().replace(/[^a-z0-9]+/g, '_') || pathOf(a.href),
          content_position: posEl ? num(posEl.getAttribute('data-position')) : indexAmong(a, 'a[href]', a.closest('.shopify-section')),
          creative_id: a.getAttribute('data-creative-id') || (img && (img.getAttribute('alt') || '').slice(0, 60)) || undefined,
          item_label: txt(a, 60),
          destination_path: pathOf(a.href),
          active_tab: panel ? (panel.getAttribute('data-tab-label') || txt(qs('.hp-collections__tab.active', a.closest('.shopify-section')), 30)) : undefined,
          is_outbound: a.host && a.host !== location.host ? true : undefined
        });
        push('content_click', p);
      });
      // Collections tabs
      on('click', '.hp-collections__tab', function (e, b) {
        push('carousel_navigate', Object.assign(sectionInfo(b), { interaction_method: 'tab', change_source: 'user', to_position: num(b.getAttribute('data-hp-tab')) + 1, tab_label: txt(b, 30) }));
      });
      // Collections tab + card views (inactive panels are display:none, so they count only once opened; the default tab counts on load)
      observeAll('.hp-collections__panel', function (panel) {
        var label = panel.getAttribute('data-tab-label');
        vis.observe(panel, function () {
          push('collection_tab_view', Object.assign(sectionInfo(panel), { tab_label: label, item_position: indexAmong(panel, '.hp-collections__panel') }));
        });
        qsa('.hp-collections__card', panel).forEach(function (card) {
          vis.observe(card, function () {
            push('collection_card_view', Object.assign(sectionInfo(card), {
              active_tab: label,
              content_id: card.getAttribute('data-content-id'),
              content_position: num(card.getAttribute('data-position')),
              item_label: txt(qs('.hp-collections__card-title', card), 60),
              destination_path: pathOf(card.href)
            }));
          });
        });
      });
      // Quick nav pill strip: horizontal scroll depth (swipe on mobile, drag on desktop), once per milestone
      observeAll('[data-hp-quick-nav]', function (track) {
        var sent = {};
        var queued = false;
        track.addEventListener('scroll', function () {
          if (queued) return;
          queued = true;
          setTimeout(function () { queued = false; reportScroll(); }, 300);
        }, { passive: true });
        function reportScroll() {
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 4) return;
          var pct = Math.round(track.scrollLeft / max * 100);
          var items = qsa('.hp-quick-nav__item', track);
          var edge = track.getBoundingClientRect().right + 1;
          var last;
          items.forEach(function (it) { if (it.getBoundingClientRect().right <= edge) last = it; });
          [25, 50, 75, 100].forEach(function (m) {
            if (sent[m] || pct < (m === 100 ? 98 : m)) return;
            sent[m] = true;
            push('quick_nav_scroll', Object.assign(sectionInfo(track), {
              progress_pct: m,
              content_position: last ? num(last.getAttribute('data-position')) : undefined,
              item_label: txt(last, 60),
              item_count: items.length
            }));
          });
        }
      });
      // Features accordion
      on('click', '.hp-features__item-title', function (e, t) {
        var item = t.closest('[data-hp-feature]');
        push('accordion_toggle', Object.assign(sectionInfo(t), { block_id: item ? 'feature_' + item.getAttribute('data-hp-feature') : undefined, title: txt(t, 60), state: item && item.classList.contains('active') ? 'close' : 'open' }));
      });
      // Testimonials fader
      var autoCount = 0;
      qsa('[data-hp-testimonial]').forEach(function (slide) {
        new MutationObserver(function () {
          if (!slide.classList.contains('active')) return;
          var sec = slide.closest('.shopify-section');
          var user = recentPointer(900) && sec && sec.contains(lastPointerTarget);
          var method = user ? (lastPointerTarget.closest('[data-hp-testimonial-dot]') ? 'dot' : (lastPointerTarget.closest('[data-hp-testimonial-nav]') ? 'logo' : 'swipe')) : undefined;
          if (!user) { if (autoCount >= 10 || !isVisible(slide)) return; autoCount++; }
          push('carousel_navigate', Object.assign(sectionInfo(slide), { to_position: num(slide.getAttribute('data-hp-testimonial')) + 1, interaction_method: method, change_source: user ? 'user' : 'automatic' }));
        }).observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
      // UGC Swiper
      var lastArrowTs = 0;
      on('click', '.hp-ugc-swiper-prev, .hp-ugc-swiper-next', function () { lastArrowTs = Date.now(); });
      var tries = 0;
      (function bindSwiper() {
        var el = qs('.hp-ugc-videos-swiper');
        var sw = el && el.swiper;
        if (!sw) { if (tries++ < 40) setTimeout(bindSwiper, 250); return; }
        var prev = sw.realIndex;
        sw.on('slideChange', function () {
          var to = sw.realIndex;
          if (to === prev) return;
          var method = Date.now() - lastArrowTs < 500 ? 'arrow' : (recentPointer(900) ? (lastPointerTarget && lastPointerTarget.closest('.swiper-slide') && !lastPointerTarget.closest('.swiper-slide-active') ? 'click_slide' : 'swipe') : 'unknown');
          push('carousel_navigate', Object.assign(sectionInfo(el), { from_position: prev + 1, to_position: to + 1, interaction_method: method, change_source: 'user', slide_count: sw.slides ? sw.slides.length : undefined }));
          prev = to;
        });
      })();
    }

    // Quiz (page.quiz / page.quiz-cushion)
    on('click', '[data-quiz-answer]', function (e, b) {
      push('quiz_step', { step: num(b.getAttribute('data-step')), answer: b.getAttribute('data-answer'), answer_label: txt(b, 40) });
    });
    on('click', '[data-quiz-see-results]', function () {
      setTimeout(function () {
        var res = qs('.quiz-results__collection.is-active');
        push('quiz_results_view', { result_collection: res && res.getAttribute('data-collection-handle'), results_count: res ? qsa('[data-gpcard]', res).length : undefined });
      }, 100);
    });
    on('click', '.quiz-results__collection a[href]', function (e, a) {
      var card = a.closest('[data-gpcard]');
      push('quiz_result_click', { result_collection: (a.closest('.quiz-results__collection') || {}).getAttribute && a.closest('.quiz-results__collection').getAttribute('data-collection-handle'), item_id: card && card.getAttribute('data-product-id'), item_position: card ? indexAmong(card, '[data-gpcard]', a.closest('.quiz-results__collection')) : undefined, destination_path: pathOf(a.href) });
    });
  }

  /* ================================================================= VIDEO */
  function initVideo() {
    observeAll('video', function (v) {
      var state = { started: false, marks: {} };
      function ctx() {
        var info = sectionInfo(v);
        var blockEl = v.closest('[data-block-id]');
        var slide = v.closest('.swiper-slide, [data-position]');
        var media = v.closest('.product-gallery__media');
        return Object.assign(info, {
          content_id: blockEl ? blockEl.getAttribute('data-block-id') : (media ? media.getAttribute('data-media-id') : undefined),
          video_position: slide ? (num(slide.getAttribute('data-position')) || num(slide.getAttribute('data-swiper-slide-index')) + 1 || indexAmong(slide, '.swiper-slide')) : (media ? mediaPosition(media) : undefined),
          item_id: CFG.pageType === 'product' ? currentProduct().item_id : undefined,
          muted: v.muted, duration_s: isFinite(v.duration) ? Math.round(v.duration) : undefined
        });
      }
      v.addEventListener('play', function () {
        if (state.started) return;
        state.started = true;
        state.playSource = recentPointer(1000) ? 'user' : 'autoplay';
        push('video_start', Object.assign(ctx(), { play_source: state.playSource }));
      });
      v.addEventListener('timeupdate', function () {
        if (!isFinite(v.duration) || !v.duration) return;
        var pct = (v.currentTime / v.duration) * 100;
        [25, 50, 75].forEach(function (m) {
          if (pct >= m && !state.marks[m]) { state.marks[m] = true; push('video_progress', Object.assign(ctx(), { progress_pct: m, play_source: state.playSource })); }
        });
      });
      v.addEventListener('ended', function () {
        if (state.marks[100]) return;
        state.marks[100] = true;
        push('video_complete', Object.assign(ctx(), { progress_pct: 100, play_source: state.playSource }));
      });
      v.addEventListener('volumechange', function () {
        if (v.closest('.hp-ugc-video')) push('video_mute_toggle', Object.assign(ctx(), { muted: v.muted }));
      });
    });
  }

  /* =================================================================== PLP */
  function listContext() {
    var stateEl = qs('[data-gocplp-state]');
    var state = {};
    try { state = stateEl ? JSON.parse(stateEl.textContent) : {}; } catch (e) { /* ignore */ }
    var isSearch = CFG.pageType === 'search';
    var handle = state.collectionHandle || (CFG.collection && CFG.collection.handle);
    return {
      state: state,
      item_list_id: isSearch ? 'search' : (handle ? 'collection:' + handle : 'list:' + CFG.pageType),
      item_list_name: isSearch ? 'Search results' : ((CFG.collection && CFG.collection.title) || handle || CFG.pageType)
    };
  }
  function cardItem(card, grid) {
    return clean({
      item_id: card.getAttribute('data-product-id'),
      item_name: card.getAttribute('data-product-title'),
      item_handle: card.getAttribute('data-active-handle') || card.getAttribute('data-base-handle'),
      item_category: card.getAttribute('data-product-type'),
      item_style: card.getAttribute('data-style'),
      price: num(card.getAttribute('data-product-price')),
      index: indexAmong(card, '[data-gpcard]', grid || card.closest('[data-goc-grid], [data-gocplp-grid], .quiz-results__collection, .shopify-section') || card.parentNode)
    });
  }
  function initPlp() {
    var grid = qs('[data-goc-grid], [data-gocplp-grid]');
    var hasCards = !!qs('[data-gpcard]');
    if (!grid && !hasCards) return;
    var renderId = 1;
    var batch = [];
    var flushTimer = null;
    var loadMethod = 'initial';

    function flush() {
      flushTimer = null;
      if (!batch.length) return;
      var ctx = listContext();
      push('product_impression', { item_list_id: ctx.item_list_id, item_list_name: ctx.item_list_name, render_id: renderId, load_method: loadMethod, items: batch.splice(0, batch.length) });
    }
    observeAll('[data-gpcard]', function (card) {
      if (card.closest('[data-cn-search]')) return; // overlay results are reported by the search module
      vis.observe(card, function () {
        var item = cardItem(card, card.closest('[data-goc-grid], [data-gocplp-grid]') || grid);
        item.render_id = renderId;
        batch.push(item);
        if (!flushTimer) flushTimer = setTimeout(flush, 800);
      }, { threshold: 0.5, delay: 1000 });
    });

    function activeFilters() {
      // Filter buttons keep data-active in sync after AJAX apply (both tag and metafield modes)
      var seen = {};
      return qsa('[data-goc-tag][data-active="true"], [data-goc-filter-value][data-active="true"]').map(function (b) {
        return (b.getAttribute('data-goc-group') || b.getAttribute('data-goc-filter-param') || '') + ':' + (b.getAttribute('data-goc-label') || b.getAttribute('data-goc-filter-value') || txt(b, 30));
      }).filter(function (k) { if (seen[k]) return false; seen[k] = true; return true; });
    }
    function resultsView(method) {
      var ctx = listContext();
      var s = ctx.state || {};
      var g = qs('[data-goc-grid], [data-gocplp-grid]'); // re-query: the grid node is replaced on filter/sort
      var cards = g ? qsa('[data-gpcard]', g) : qsa('[data-gpcard]');
      var count = g && g.getAttribute('data-results-count') != null ? num(g.getAttribute('data-results-count'))
        : (CFG.pageType === 'search' && CFG.searchResultsCount != null ? num(CFG.searchResultsCount)
        : (s.productsCount != null ? num(s.productsCount) : cards.length));
      var filters = activeFilters();
      var sortParam = (location.search.match(/[?&]sort_by=([^&]+)/) || [])[1];
      push('listing_results_view', {
        item_list_id: ctx.item_list_id, item_list_name: ctx.item_list_name, render_id: renderId, load_method: method,
        results_count: count, zero_results: count === 0 && cards.length === 0, cards_rendered: cards.length,
        active_filter_count: filters.length, active_filters: filters.join('|').slice(0, 100) || undefined,
        sort_order: sortParam ? decodeURIComponent(sortParam) : (s.sortBy || undefined), filter_mode: s.filterMode || undefined
      });
    }
    if (grid) resultsView('initial');
    document.addEventListener('gocplp:updated', function () { renderId++; loadMethod = 'filter'; resultsView('filter'); });
    document.addEventListener('gocplp:appended', function (e) {
      var d = e.detail || {};
      renderId++; loadMethod = d.method || 'load_more';
      push('load_more', { load_method: loadMethod, loaded_batch: d.batch, items_added: d.count, render_id: renderId });
    });

    // Filters & sort
    on('click', '[data-goc-filters-toggle]', function () { push('filter_open', {}); });
    on('click', '[data-goc-close]', function (e, b) { if (b.closest('[data-goc-drawer="filters"]')) push('filter_close', {}); });
    on('click', '[data-goc-tag], [data-goc-filter-param]', function (e, b) {
      var active = b.getAttribute('data-active') === 'true' || b.getAttribute('aria-pressed') === 'true' || b.classList.contains('is-active') || b.classList.contains('active');
      push(active ? 'filter_remove' : 'filter_apply', {
        filter_name: b.getAttribute('data-goc-group') || b.getAttribute('data-goc-filter-param'),
        filter_value: b.getAttribute('data-goc-label') || b.getAttribute('data-goc-filter-value') || txt(b, 40),
        applied_from: b.closest('[data-goc-drawer]') ? 'drawer' : 'bar'
      });
    });
    on('click', '[data-goc-apply]', function () { push('filter_apply', { applied_from: 'drawer_apply' }); });
    on('click', '[data-goc-clear], .gocf__clear', function () { push('filter_clear', {}); });
    on('click', '[data-goc-sort-toggle]', function () { push('sort_open', {}); });
    on('click', '[data-goc-sort-by]', function (e, b) { push('sort_change', { sort_order: b.getAttribute('data-goc-sort-by') }); });
    on('click', '[data-goc-load]', function () { push('load_more_click', { load_method: 'load_more' }); });
    on('click', '[data-gocplp-gender-btn]', function (e, b) {
      push('gender_toggle', { to_gender: b.getAttribute('data-gocplp-gender-btn'), to_path: pathOf(b.getAttribute('data-gocplp-gender-url')), from_path: location.pathname });
    });

    // Promo / review tiles in the grid
    observeAll('[data-gocrev-wrap]', function (tile) {
      vis.observe(tile, function () {
        push('promo_tile_view', { promo_id: tile.getAttribute('data-gocrev-promo') || 'review_card', tile_index: num(tile.getAttribute('data-gocrev-idx')), grid_position: num(tile.getAttribute('data-gocrev-pos')), render_id: renderId });
      });
    });
    on('click', '[data-gocrev-wrap] a[href]', function (e, a) {
      var tile = a.closest('[data-gocrev-wrap]');
      push('promo_tile_click', { promo_id: tile.getAttribute('data-gocrev-promo') || 'review_card', grid_position: num(tile.getAttribute('data-gocrev-pos')), destination_path: pathOf(a.href) });
    });

    // Select item (card click) + list context handoff to the PDP
    on('click', '[data-gpcard] a[data-gpcard-link], [data-gpcard] a[data-gpcard-title-link]', function (e, a) {
      var card = a.closest('[data-gpcard]');
      if (card.closest('[data-cn-search]')) return;
      var ctx = listContext();
      var item = cardItem(card, card.closest('[data-goc-grid], [data-gocplp-grid]') || grid);
      storeSet(sessionStorage, 'cro_list_ctx', JSON.stringify({ list_id: ctx.item_list_id, index: item.index, item_id: item.item_id, ts: Date.now() }));
      push('product_card_click', Object.assign(item, { item_list_id: ctx.item_list_id, item_list_name: ctx.item_list_name, render_id: renderId, link_type: a.hasAttribute('data-gpcard-title-link') ? 'title' : 'image', search_type: CFG.pageType === 'search' ? 'results_page' : undefined }));
    });

    // Card option changes
    on('click', '[data-gpcard] .gpcard__swatch', function (e, b) {
      var card = b.closest('[data-gpcard]');
      push('product_option_select', { option_type: 'color', option_value: b.getAttribute('data-sp-subtitle') || txt(b, 40), item_id: card.getAttribute('data-product-id'), to_handle: b.getAttribute('data-sp-handle'), context: 'plp_card' });
    });
    on('click', '[data-gpcard] .gpcard__more', function (e, b) {
      push('product_option_select', { option_type: 'more_colors', item_id: b.closest('[data-gpcard]').getAttribute('data-product-id'), context: 'plp_card' });
    });

    // Quick add
    function cardListCtx(card) {
      if (!card) return {};
      var ctx = listContext();
      var item = cardItem(card, card.closest('[data-goc-grid], [data-gocplp-grid]') || grid);
      return { item_list_id: ctx.item_list_id, list_position: item.index, item_id: item.item_id, item_name: item.item_name };
    }
    on('click', '[data-gpcard-quick]', function (e, b) {
      var card = b.closest('[data-gpcard]');
      lastAtc = Object.assign({ source: 'plp_quick_add_sheet', ts: Date.now() }, cardListCtx(card));
      push('quick_add_open', Object.assign(cardListCtx(card), { item_handle: b.getAttribute('data-product-handle'), layout: 'mobile_sheet' }));
    });
    on('click', '[data-gpcard] .gpcard__sizeBtn', function (e, b) {
      var card = b.closest('[data-gpcard]');
      lastAtc = Object.assign({ source: 'plp_quick_add', variant_id: b.getAttribute('data-variant-id'), ts: Date.now() }, cardListCtx(card));
      push('atc_attempt', { atc_source: 'plp_quick_add', item_id: lastAtc.item_id, item_list_id: lastAtc.item_list_id, list_position: lastAtc.list_position, variant_id: lastAtc.variant_id, option_value: b.getAttribute('data-size'), size_selected: true });
    });
    on('click', '[data-gocqa-cta]', function (e, b) {
      lastAtc = Object.assign({}, lastAtc && lastAtc.item_list_id ? lastAtc : {}, { source: 'plp_quick_add_sheet', ts: Date.now() });
      push('atc_attempt', { atc_source: 'plp_quick_add_sheet', item_id: lastAtc.item_id, item_list_id: lastAtc.item_list_id, list_position: lastAtc.list_position, size_selected: !b.disabled });
    });
    // Wrap the single PLP add-to-cart entry point for success/error
    var tries = 0;
    (function wrapAdd() {
      var g = window.__GOC_PLP__;
      if (!g || typeof g.addToCart !== 'function') { if (tries++ < 40) setTimeout(wrapAdd, 250); return; }
      if (g.addToCart.__croWrapped) return;
      var orig = g.addToCart;
      var wrapped = function (variantId, qty) {
        var fresh = lastAtc && Date.now() - lastAtc.ts < 10000 ? lastAtc : null;
        var src = fresh ? fresh.source : 'plp_quick_add';
        var base = { atc_source: src, variant_id: String(variantId), item_id: fresh && fresh.item_id, item_list_id: fresh && fresh.item_list_id, list_position: fresh && fresh.list_position };
        var res;
        try { res = orig.apply(this, arguments); } catch (err) { push('atc_error', Object.assign({}, base, { error_type: classifyError(err) })); throw err; }
        if (res && typeof res.then === 'function') {
          res.then(function () {
            setCartSource('quick_add');
            push('atc_success', Object.assign({}, base, { quantity: qty || 1, time_on_page_ms: Date.now() - pageLoadTs }));
          }, function (err) {
            push('atc_error', Object.assign({}, base, { error_type: classifyError(err) }));
          });
        }
        return res;
      };
      wrapped.__croWrapped = true;
      g.addToCart = wrapped;
    })();
  }
  var lastAtc = null;
  function classifyError(err) {
    var msg = (err && (err.message || err.description || err.toString())) || '';
    if (/blocked|pre-?order|cutoff/i.test(msg)) return 'unavailable_variant';
    if (/sold out|unavailable|stock|inventory/i.test(msg)) return 'unavailable_variant';
    if (/size/i.test(msg)) return 'size_required';
    if (/network|fetch|failed|50\d|422/i.test(msg)) return 'cart_request_failed';
    return 'other';
  }

  /* =================================================================== PDP */
  /** 1-based position among the visible slides, the same numbering as the carousel index in gallery_navigate (aria-label counts hidden media too). */
  function mediaPosition(media) {
    return indexAmong(media, '.product-gallery__media:not([hidden])', media.parentNode);
  }
  function currentProduct() {
    var form = qs('form[action*="/cart/add"]');
    var pid = form && qs('input[name="product-id"]', form);
    var vid = form && qs('input[name="id"]', form);
    var handle = location.pathname.split('/products/')[1] ? location.pathname.split('/products/')[1].split('/')[0] : (CFG.product && CFG.product.handle);
    return clean(Object.assign({
      item_id: (pid && pid.value) || (CFG.product && String(CFG.product.id)),
      variant_id: vid && vid.value,
      item_handle: handle,
      item_style: CFG.product && CFG.product.style
    }, sourceList()));
  }
  function selectedSize() {
    var fs = qs('fieldset.variant-picker-size');
    var inp = fs && qs('input:checked', fs);
    var label = inp && (qs('label[for="' + inp.id + '"]', fs) || inp.nextElementSibling);
    return inp ? { selected: true, size: txt(label, 10) || inp.value, variant_id: inp.getAttribute('data-variant-id') } : { selected: false };
  }
  function initPdp() {
    if (CFG.pageType !== 'product') return;
    var inited = new WeakSet();
    var state = { sizeChanges: 0, lastSwatchTs: 0, stickyTs: 0, galleryId: null, availabilitySeen: {}, bundleErrTs: 0 };

    function initGallery(gal) {
      if (inited.has(gal)) return;
      inited.add(gal);
      var prod = currentProduct();
      var gid = prod.item_handle || prod.item_id;
      state.galleryId = gid;
      var mediaEls = qsa('.product-gallery__media', gal).filter(function (m) { return !m.hasAttribute('hidden'); });
      var count = mediaEls.length;
      var seen = new Set();
      // 30% of the gallery, or 30% of the viewport when the desktop grid is too tall to ever be 30% on screen
      vis.observe(gal, function () {
        push('gallery_view', Object.assign({}, prod, { gallery_id: gid, media_count: count, layout: mobileMQ.matches ? 'slider' : 'grid' }));
      }, { threshold: Math.min(0.3, (window.innerHeight * 0.3) / (gal.offsetHeight || 1)), delay: 1000 });
      mediaEls.forEach(function (m) {
        vis.observe(m, function () {
          var pos = mediaPosition(m);
          seen.add(pos);
          push('gallery_media_view', Object.assign({}, prod, {
            gallery_id: gid, media_id: m.getAttribute('data-media-id'), media_position: pos, media_count: count,
            media_type: m.getAttribute('data-media-type'), is_last: pos === count, seen_count: seen.size, all_seen: seen.size >= count && count > 0
          }));
        }, { threshold: 0.5, delay: 1000 });
      });
      var carousel = qs('.product-gallery__carousel', gal);
      if (carousel) {
        var prev = null;
        carousel.addEventListener('carousel:change', function (e) {
          var d = e.detail || {};
          var to = d.index != null ? d.index + 1 : undefined;
          if (to === prev) return;
          var fromVariant = Date.now() - state.lastSwatchTs < 1500;
          var method = fromVariant ? undefined : (lastPointerTarget && lastPointerTarget.closest && lastPointerTarget.closest('.page-dots, carousel-navigation') ? 'dot' : (recentPointer(1200) ? 'swipe' : 'unknown'));
          push('gallery_navigate', Object.assign({}, prod, { gallery_id: gid, from_position: prev, to_position: to, media_count: count, interaction_method: method, change_source: fromVariant ? 'variant_change' : 'user' }));
          prev = to;
        });
      }
      var lastZoomTs = 0;
      gal.addEventListener('lightbox:open', function (e) {
        // iOS pinch dispatches lightbox:open on every gesturechange past the zoom scale; count one zoom per gesture
        if (Date.now() - lastZoomTs < 1500) return;
        lastZoomTs = Date.now();
        push('gallery_zoom', Object.assign({}, prod, { gallery_id: gid, media_position: e.detail && e.detail.index != null ? e.detail.index + 1 : undefined }));
      });
    }
    function initBlocks() {
      var types = { rating: 1, accordion: 1, 'product-bundle': 1, 'product-ugc-videos': 1, '@app': 1, 'back-in-stock-waitlist': 1, 'buy-buttons': 1, colorway: 1 };
      qsa('[data-block-id][data-block-type]').forEach(function (b) {
        var t = b.getAttribute('data-block-type');
        if (!types[t] || inited.has(b)) return;
        inited.add(b);
        vis.observe(b, function () {
          push('section_view', Object.assign(currentProduct(), { section_id: b.getAttribute('data-block-id'), section_type: 'pdp_' + t.replace('@', ''), section_title: txt(qs('summary, h2, h3', b), 60), section_position: indexAmong(b, '[data-block-id]') }));
        });
      });
      // Reviews: #yotpo-container, not the first .yotpo-widget-instance (that is the loyalty floater injected at the top of <body>)
      [['#yotpo-container', 'pdp_reviews_widget'], ['#yotpo-product-points-widget, .yotpo-product-points-widget', 'pdp_rewards_bar'], ['.attn-waitlist-wrapper', 'pdp_back_in_stock']].forEach(function (pair) {
        var el = qs(pair[0]);
        if (!el || inited.has(el)) return;
        inited.add(el);
        vis.observe(el, function () { push('section_view', Object.assign(currentProduct(), { section_id: pair[1], section_type: pair[1] })); });
      });
      var main = qs('.buy-buttons__atc-wrap') || qs('buy-buttons') || qs('[data-select-size-button]');
      if (main && !inited.has(main)) { inited.add(main); vis.observe(main, function () { push('atc_view', Object.assign(currentProduct(), { atc_source: 'pdp_main', atc_state: selectedSize().selected ? 'ready' : 'select_size' })); }, { threshold: 0.5 }); }
      var sticky = qs('#product-sticky-b-button');
      if (sticky && !inited.has(sticky)) { inited.add(sticky); vis.observe(sticky, function () { push('atc_view', Object.assign(currentProduct(), { atc_source: 'pdp_sticky' })); }, { threshold: 0.5 }); }
    }
    function initAll() {
      var gal = qs('product-gallery');
      if (gal) initGallery(gal);
      initBlocks();
    }
    initAll();
    domChangedHooks.push(function () { if (qs('product-gallery') && !inited.has(qs('product-gallery'))) { state.sizeChanges = 0; initAll(); } else initBlocks(); });

    // Colorway (separate product) selection
    on('click', 'a.thumbnail-swatch, a.color-swatch', function (e, a) {
      state.lastSwatchTs = Date.now();
      var disabled = a.classList.contains('is-disabled');
      var p = Object.assign(currentProduct(), {
        to_handle: pathOf(a.getAttribute('href')).split('/').pop(), colorway: a.getAttribute('data-swatch-tooltip') || txt(a, 40),
        swatch_position: indexAmong(a, 'a.thumbnail-swatch, a.color-swatch', a.closest('fieldset') || a.parentNode),
        swatch_group: txt(a.closest('fieldset') ? qs('legend', a.closest('fieldset')) : null, 30), unavailable_for_size: disabled
      });
      push('color_select', p);
      if (disabled) push('unavailable_option_attempt', Object.assign(currentProduct(), { option_type: 'color', option_value: p.colorway }));
    });
    on('click', '.gender-toggle a', function (e, a) {
      push('product_option_select', Object.assign(currentProduct(), { option_type: 'gender', option_value: txt(a, 20), to_path: pathOf(a.href) }));
    });

    // Size selection / availability
    document.addEventListener('variant:change', function (e) {
      var v = (e.detail && e.detail.variant) || {};
      state.sizeChanges++;
      var sz = selectedSize();
      var availability = v.available === false ? 'sold_out' : 'in_stock';
      push('size_select', Object.assign(currentProduct(), { variant_id: v.id ? String(v.id) : sz.variant_id, size: sz.size, available: v.available, change_count: state.sizeChanges }));
      var key = String(v.id || sz.variant_id);
      if (!state.availabilitySeen[key]) {
        state.availabilitySeen[key] = true;
        push('availability_view', Object.assign(currentProduct(), { variant_id: key, size: sz.size, availability: availability }));
      }
    });
    on('click', 'label.block-swatch.is-disabled', function (e, l) {
      push('unavailable_option_attempt', Object.assign(currentProduct(), { option_type: 'size', option_value: txt(l, 10) }));
    });
    on('click', '#attn-waitlist-trigger, #attn-waitlist-trigger-btn, .back-in-stock-disney-cta', function (e, b) {
      push('back_in_stock_click', Object.assign(currentProduct(), { size: selectedSize().size, source: b.classList.contains('back-in-stock-disney-cta') ? 'disney_cta' : 'attentive' }));
    });

    // Size chart, accordions, reviews, rewards
    on('click', '#size-guide-link-button, .size-guide-link, a[href="#size-guide-link-button"]', function (e, el) {
      push('size_chart_open', Object.assign(currentProduct(), { source: el.closest('#product-sticky') ? 'sticky_plus' : 'link' }));
    });
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || !d.matches || !d.matches('details.accordion__disclosure')) return;
      var block = d.closest('[data-block-id]');
      push('accordion_toggle', Object.assign(currentProduct(), { block_id: block && block.getAttribute('data-block-id'), title: txt(qs('summary', d), 60), state: d.open ? 'open' : 'close' }));
    }, true);
    on('click', '.rating-badge a, #read-reviews-desktop, #read-reviews-mobile, a[href="#yotpo"]', function (e, a) {
      push('reviews_click', Object.assign(currentProduct(), { source: a.closest('.rating-badge') ? 'rating_badge' : 'read_reviews_link' }));
    });
    // Yotpo reviews widget (rendered in-page, markup verified 2026-10-21): classify what was clicked
    function yotpoInteraction(el) {
      var aria = el.getAttribute('aria-label') || '';
      var is = function (sel) { return el.matches(sel); };
      var ddLabel = function (btn) { return btn ? txt(btn, 30).replace(/All\b.*$/, '').replace(/:.*$/, '').trim().toLowerCase() : undefined; };
      if (is('.yotpo-new-review-btn')) return { interaction: 'write_review' };
      if (is('.yotpo-review-votes-icons')) return { interaction: /not helpful/i.test(aria) ? 'vote_not_helpful' : 'vote_helpful' };
      if (is('.yotpo-reviews-pagination-item')) { var pg = aria.match(/page (\d+)/i); return { interaction: 'pagination', filter_value: /previous/i.test(aria) ? 'prev' : (/next/i.test(aria) ? 'next' : (pg ? pg[1] : (el.textContent || '').trim().slice(0, 5))) }; }
      if (is('.yotpo-score-option, .yotpo-distribution-row')) { var r = aria.match(/(\d) (?:score|star)/); return { interaction: 'filter_rating', filter_name: 'rating', filter_value: r ? r[1] : (/all/i.test(aria) ? 'all' : undefined) }; }
      if (is('.yotpo-media-select')) return { interaction: 'filter_media', filter_name: 'media' };
      if (is('.yotpo-smart-topic-filter')) return { interaction: 'filter_topic', filter_name: 'topic', filter_value: txt(el, 30).toLowerCase() };
      if (is('.yotpo-smart-topics-see-more-label')) return { interaction: 'topics_show_more' };
      if (is('.yotpo-dropdown-option')) {
        var wrap = el.closest('[class*="yotpo-dropdown"]:not(.yotpo-dropdown-option)');
        var btn = wrap && (qs('.yotpo-dropdown-closable', wrap) || (wrap.parentNode && qs('.yotpo-dropdown-closable', wrap.parentNode)));
        var isSort = !!(el.closest('.yotpo-reviews-widget-dropdown') || (btn && btn.classList.contains('yotpo-reviews-widget-dropdown')));
        return { interaction: isSort ? 'sort' : 'filter_select', filter_name: isSort ? 'sort' : ddLabel(btn), filter_value: txt(el, 30).toLowerCase() };
      }
      if (is('.yotpo-dropdown-closable')) return { interaction: 'dropdown_open', filter_name: el.classList.contains('yotpo-reviews-widget-dropdown') ? 'sort' : ddLabel(el) };
      if (is('.yotpo-icon-button')) return { interaction: 'search' };
      if (is('img, [class*="image"], [class*="media"], [class*="thumbnail"]') || qs('img', el)) return { interaction: 'media_open' };
      if (/read more|show more|see more/i.test(txt(el, 20))) return { interaction: 'read_more' };
      return { interaction: 'other', element_label: txt(el, 40) };
    }
    on('click', '.yotpo-widget-instance button, .yotpo-widget-instance a, .yotpo-widget-instance [role="button"], .yotpo-widget-instance .yotpo-score-option, .yotpo-widget-instance .yotpo-dropdown-option, .yotpo-widget-instance .yotpo-smart-topic-filter, .yotpo-widget-instance .yotpo-smart-topics-see-more-label, .yotpo-widget-instance .yotpo-distribution-row', function (e, el) {
      if (el.closest('.yotpo-widget-loyalty-floater-widget, .yotpo-product-points-widget')) return;
      push('reviews_click', Object.assign(currentProduct(), { source: 'widget' }, yotpoInteraction(el)));
    });
    on('change', '.yotpo-widget-instance .yotpo-search-input', function (e, inp) {
      push('reviews_click', Object.assign(currentProduct(), { source: 'widget', interaction: 'search', filter_name: 'search', filter_value: scrubTerm(inp.value), query_length: (inp.value || '').length }));
    });
    on('click', '.yotpo-product-points-widget a, .yotpo-product-points-widget button, #yotpo-product-points-widget a, #yotpo-product-points-widget button', function (e, el) {
      push('rewards_click', Object.assign(currentProduct(), { element_label: txt(el, 40) }));
    });

    // Bundle ("Make it a set")
    on('click', '.pdp_bundle-product-swatch', function (e, b) {
      push('bundle_select', Object.assign(currentProduct(), { bundle_item_handle: b.getAttribute('data-product-handle'), swatch_position: indexAmong(b, '.pdp_bundle-product-swatch') }));
    });
    on('click', '#pdpBundleAtc', function () {
      var sz = selectedSize();
      lastAtc = { source: 'bundle', ts: Date.now() };
      setCartSource('bundle');
      push('atc_attempt', Object.assign(currentProduct(), { atc_source: 'bundle', size_selected: sz.selected, size: sz.size }));
    });
    var bundleErr = qs('#pdpBundleSelectorError');
    if (bundleErr) new MutationObserver(function () {
      if (!isVisible(bundleErr) || !txt(bundleErr) || Date.now() - state.bundleErrTs < 1000) return;
      state.bundleErrTs = Date.now();
      push('atc_error', Object.assign(currentProduct(), { atc_source: 'bundle', error_type: 'size_required' }));
    }).observe(bundleErr, { attributes: true, childList: true, subtree: true });

    // Add to cart
    on('click', '[data-select-size-button]', function () {
      var src = Date.now() - state.stickyTs < 500 ? 'pdp_sticky' : 'pdp_main';
      push('atc_attempt', Object.assign(currentProduct(), { atc_source: src, size_selected: false }));
      push('atc_error', Object.assign(currentProduct(), { atc_source: src, error_type: 'size_required' }));
    });
    on('click', '#product-sticky-b-button', function () {
      state.stickyTs = Date.now();
      var sz = selectedSize();
      if (!sz.selected || !isVisible(qs('.buy-buttons__atc-wrap button[type=submit]'))) {
        push('atc_attempt', Object.assign(currentProduct(), { atc_source: 'pdp_sticky', size_selected: false }));
        push('atc_error', Object.assign(currentProduct(), { atc_source: 'pdp_sticky', error_type: 'size_required' }));
      }
    });
    on('click', '.buy-buttons__atc-wrap button[type=submit]', function () {
      var src = Date.now() - state.stickyTs < 500 ? 'pdp_sticky' : 'pdp_main';
      var sz = selectedSize();
      lastAtc = { source: src, ts: Date.now() };
      push('atc_attempt', Object.assign(currentProduct(), { atc_source: src, size_selected: sz.selected, size: sz.size, variant_id: sz.variant_id || currentProduct().variant_id, size_change_count: state.sizeChanges }));
    });
    document.addEventListener('variant:add', function (e) {
      var items = (e.detail && e.detail.items) || [];
      var src = lastAtc && Date.now() - lastAtc.ts < 15000 ? lastAtc.source : 'pdp_main';
      push('atc_success', Object.assign(currentProduct(), { atc_source: src, variant_id: items[0] && items[0].variant_id ? String(items[0].variant_id) : undefined, quantity: items[0] && items[0].quantity, time_on_page_ms: Date.now() - pageLoadTs, size_change_count: state.sizeChanges }));
    });
    document.addEventListener('cart:error', function (e) {
      var src = lastAtc && Date.now() - lastAtc.ts < 15000 ? lastAtc.source : 'pdp_main';
      push('atc_error', Object.assign(currentProduct(), { atc_source: src, error_type: classifyError(e.detail && e.detail.error) }));
    }, true);
  }

  /* ================================================================== CART */
  function initCart() {
    var drawer = qs('#cart-drawer');
    var st = { openedAt: 0, checkoutClicked: false, lastShipping: '', upsellClickTs: 0, countBefore: null };

    function readShipping(context) {
      var bar = qs('.free-shipping-container');
      if (!bar || !isVisible(bar)) return;
      var header = txt(qs('.free-shipping-header', bar));
      var reached = /free shipping!|hooray/i.test(header);
      var m = header.match(/\$?\s*([\d,.]+)\s*(?:away|from)/i);
      var amount = reached ? 0 : (m ? num(m[1].replace(/,/g, '')) : undefined);
      var key = context + '|' + reached + '|' + amount;
      if (key === st.lastShipping) return;
      st.lastShipping = key;
      push('shipping_progress_view', Object.assign(cartParams(), { shipping_threshold: CFG.shippingThreshold, amount_to_threshold: amount, reached: reached, cart_type: context }));
    }
    function observeUpsells() {
      var gwp = qs('#cart-gwp');
      if (gwp) { vis.release(gwp); vis.observe(gwp, function () { push('cart_upsell_view', Object.assign(cartParams(), { upsell_type: 'gwp_socks', upsell_position: 1 })); }, { threshold: 0.5 }); }
      var cross = qs('.cart-drawer__complementary-products');
      if (cross && cross.children.length) { vis.release(cross); vis.observe(cross, function () { push('cart_upsell_view', Object.assign(cartParams(), { upsell_type: 'cross_sell', items_count: qsa('product-card-horizontal, .product-card-horizontal', cross).length })); }, { threshold: 0.5 }); }
    }

    if (drawer) {
      drawer.addEventListener('dialog:after-show', function () {
        st.openedAt = Date.now(); st.checkoutClicked = false;
        var source = getCartSource();
        fetchCart().then(function (c) {
          push('cart_open', Object.assign(cartParams(c), { cart_type: 'drawer', open_source: source, cart_empty: !c || c.item_count === 0 }));
          readShipping('drawer');
          observeUpsells();
        });
      });
      drawer.addEventListener('dialog:after-hide', function () {
        if (!st.openedAt) return;
        push('cart_close', Object.assign(cartParams(), { cart_type: 'drawer', time_open_ms: Date.now() - st.openedAt, checkout_clicked: st.checkoutClicked }));
        st.openedAt = 0; st.lastShipping = '';
      });
      drawer.addEventListener('cart-drawer:refreshed', function () { readShipping('drawer'); observeUpsells(); });
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            if (n.nodeType !== 1) return;
            var alert = n.matches && n.matches('[role="alert"], .banner--error, p.text-error') ? n : (n.querySelector ? n.querySelector('[role="alert"], .banner--error, p.text-error') : null);
            if (!alert) return;
            var msg = txt(alert);
            push('cart_error', Object.assign(cartParams(), { cart_type: 'drawer', error_type: /only|maximum|limit|can only/i.test(msg) ? 'quantity_limit' : (/sold out|unavailable|stock/i.test(msg) ? 'unavailable_variant' : 'other') }));
          });
        });
      }).observe(drawer, { childList: true, subtree: true });
    }
    if (CFG.pageType === 'cart') {
      fetchCart().then(function (c) {
        push('cart_open', Object.assign(cartParams(c), { cart_type: 'page', open_source: 'page', cart_empty: !c || c.item_count === 0 }));
        readShipping('page');
        observeUpsells();
      });
    }

    // Quantity changes
    document.addEventListener('line-item:will-change', function (e) {
      var li = e.target;
      var input = li.querySelector && li.querySelector('.quantity-selector__input');
      li.__croBefore = input ? num(input.value) : undefined;
      li.__croKey = input && input.getAttribute('data-line-key');
    }, true);
    document.addEventListener('line-item:change', function (e) {
      var li = e.target; var d = e.detail || {};
      if (d.cart) cartCache = d.cart;
      var after = num(d.quantity);
      var before = li.__croBefore;
      var line = (d.cart && d.cart.items || []).filter(function (it) { return it.key === li.__croKey; })[0];
      push('cart_quantity_change', Object.assign(cartParams(d.cart), {
        cart_type: li.closest('#cart-drawer') ? 'drawer' : 'page', quantity_before: before, quantity_after: after,
        change_type: after === 0 ? 'remove' : (before != null && after > before ? 'increase' : 'decrease'),
        item_id: line ? String(line.product_id) : undefined, variant_id: line ? String(line.variant_id) : undefined, item_name: line ? line.product_title : txt(li.querySelector && li.querySelector('.line-item__title, a'), 60)
      }));
    }, true);
    on('click', 'a[href*="/cart/change"][aria-label*="emove"], a[href*="quantity=0"]', function (e, a) {
      var li = a.closest('line-item');
      push('cart_remove_click', Object.assign(cartParams(), { cart_type: a.closest('#cart-drawer') ? 'drawer' : 'page', item_name: txt(li && li.querySelector('.line-item__title, a'), 60) }));
    });

    // Checkout / continue
    on('click', '[name="checkout"], a[href*="/checkout"]', function (e, b) {
      st.checkoutClicked = true;
      push('cart_checkout_click', Object.assign(cartParams(), { cart_type: b.closest('#cart-drawer') ? 'drawer' : (CFG.pageType === 'cart' ? 'page' : 'other'), button_type: b.tagName === 'A' ? 'link' : 'button' }));
    });
    on('click', '.cart-empty-link', function (e, a) {
      push('cart_continue_shopping', { cart_type: a.closest('#cart-drawer') ? 'drawer' : 'page', destination_path: pathOf(a.href) });
    });

    // GWP upsell click → add detection
    on('click', '#cart-gwp .gwp-size-swatch, #cart-gwp .gwp-color-input, #cart-gwp label, #cart-gwp button', function (e, el) {
      st.upsellClickTs = Date.now();
      st.countBefore = cartCache ? cartCache.item_count : null;
      push('cart_upsell_click', Object.assign(cartParams(), { upsell_type: 'gwp_socks', option_value: txt(el, 20) || (el.value || undefined) }));
    });
    on('click', '.cart-drawer__complementary-products a[href], .cart-drawer__complementary-products button', function (e, el) {
      st.upsellClickTs = Date.now();
      st.countBefore = cartCache ? cartCache.item_count : null;
      push('cart_upsell_click', Object.assign(cartParams(), { upsell_type: 'cross_sell', item_label: txt(el, 60), destination_path: el.href ? pathOf(el.href) : undefined }));
    });
    document.addEventListener('cart:refresh', function () {
      if (Date.now() - st.upsellClickTs > 8000) return;
      var before = st.countBefore;
      st.upsellClickTs = 0;
      fetchCart().then(function (c) {
        if (c && before != null && c.item_count > before) { setCartSource('upsell'); push('cart_upsell_add', Object.assign(cartParams(c), { upsell_type: 'gwp_socks' })); }
      });
    });
  }

  /* ================================================================== BOOT */
  function boot() {
    try { initNav(); } catch (e) { if (DEBUG) console.error('[cro] nav', e); }
    try { initSearch(); } catch (e) { if (DEBUG) console.error('[cro] search', e); }
    try { initSections(); } catch (e) { if (DEBUG) console.error('[cro] sections', e); }
    try { initVideo(); } catch (e) { if (DEBUG) console.error('[cro] video', e); }
    try { initPlp(); } catch (e) { if (DEBUG) console.error('[cro] plp', e); }
    try { initPdp(); } catch (e) { if (DEBUG) console.error('[cro] pdp', e); }
    try { initCart(); } catch (e) { if (DEBUG) console.error('[cro] cart', e); }
    window.CRO = { push: push, version: VERSION, observe: vis.observe };
    if (DEBUG) console.log('[cro] booted', CFG);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
